import type { ReactNode } from "react";

type EyebrowProps = {
  children: ReactNode;
  /** "brand" shows a leading brand-coloured bar; "muted" is plain uppercase. */
  tone?: "brand" | "muted";
};

export function Eyebrow({ children, tone = "brand" }: EyebrowProps) {
  if (tone === "muted") {
    return (
      <span className="text-xs font-medium uppercase tracking-[0.18em] text-neutral-500">
        {children}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-2 text-xs font-medium tracking-tight text-neutral-950">
      <span className="block h-5 w-[3px] rounded-sm bg-brand" />
      {children}
    </span>
  );
}
